export enum Page {
  FOLDER = 'FOLDER',
  OPEN_BY_FILE_NODE_ID = 'OPEN_BY_FILE_NODE_ID',
  SEARCH = 'SEARCH',
  SHARED_FOLDER = 'SHARED_FOLDER',
  SHARED_LINKS = 'SHARED_LINKS',
  FAVORITES = 'FAVORITES',
  TRASH = 'TRASH',
  FILE_PREVIEW = 'FILE_PREVIEW',
  NOT_FOUND = 'NOT_FOUND',
}
